class TasksContext {
  static nrSeqAgenda?: number;
  static nrAtendimento?: number;
  static cdMedico: string;
  static ieTipoAgenda: number;
  static eventType: string;
  static selectedCardId: string;
  static taskDateToFilter?: string;
}

export default TasksContext;